<template>
  <div id="dashboard-custom">
    <b-card no-body v-if="arr.dashboard.length">
      <b-tabs card>
        <template v-slot:tabs-end>
          <li v-if="!isMobile && showDashboardActions" class="nav-item dashboard-tabs-actions">
            <div class="buttons-dashboard-widgets" @click.stop>
              <b-link class="dashboard-lock-btn mr-2"
                      :class="{ 'is-locked': isDashboardLocked(dashboardActive) }"
                      @click="toggleDashboardLock(dashboardActive)"
                      v-b-tooltip.hover
                      :title="isDashboardLocked(dashboardActive) ? 'Dashboard bloqueado. Click para desbloquear' : 'Click para bloquear el dashboard'">
                <b-icon :icon="isDashboardLocked(dashboardActive) ? 'lock-fill' : 'unlock'"></b-icon>
              </b-link>

              <b-dropdown size="sm" variant="outline-dark" dropleft no-caret class="mr-1">
                <template v-slot:button-content>
                  <i class="icon-speedometer"></i> Panel
                </template>

                <b-dropdown-item v-if="arr.dashboard.length" @click="openNewDashboard()" title="Agregar Panel de Control">
                  <i class="fa fa-plus"></i> Agregar
                </b-dropdown-item>
                <b-dropdown-item @click="openEditDashboard(dashboardActive)" title="Editar Panel de Control">
                  <i class="fa fa-edit"></i> Editar
                </b-dropdown-item>
                <b-dropdown-item @click="moveDashboard(dashboardActive, -1)" title="Mover a la izquierda">
                  <i class="fa fa-arrow-left"></i> Mover izquierda
                </b-dropdown-item>
                <b-dropdown-item @click="moveDashboard(dashboardActive, 1)" title="Mover a la derecha">
                  <i class="fa fa-arrow-right"></i> Mover derecha
                </b-dropdown-item>
                <b-dropdown-item @click="openImportDashboard()" title="Importar tablero">
                  <i class="fa fa-download"></i> Importar
                </b-dropdown-item>
                <b-dropdown-item @click="openDeleteDashboard(dashboardActive)" title="Eliminar panel de control">
                  <i class="fa fa-trash"></i> Eliminar
                </b-dropdown-item>
              </b-dropdown>

              <b-button v-if="!isDashboardLocked(dashboardActive)"
                        size="sm"
                        variant="outline-info"
                        @click="openAddWidget(dashboardActive)"
                        v-b-tooltip.hover
                        title="Agregar Widgets">
                <i class="icon-calculator"></i> Widget
              </b-button>
            </div>
          </li>
        </template>
        <b-tab  :title="value.name"
                v-for="(value, key) in arr.dashboard"
                :key="value.id"
                @click="setDashboardActive(value)"
                :active="value.id == tabActive">
        
          <b-card-text>
            <div v-if="isMobile && showDashboardActions" class="mobile-dashboard-actions">
              <b-dropdown size="sm" variant="outline-dark" right>
                <template v-slot:button-content>
                  <b-icon
                    :icon="isDashboardLocked(dashboardActive) ? 'lock-fill' : 'unlock'"
                    class="dashboard-lock-btn"
                    :class="{ 'is-locked': isDashboardLocked(dashboardActive) }"
                  ></b-icon>
                </template>

                <b-dropdown-item disabled>
                  <b-icon :icon="isDashboardLocked(dashboardActive) ? 'lock-fill' : 'unlock'"></b-icon>
                  {{ isDashboardLocked(dashboardActive) ? 'Estado: bloqueado' : 'Estado: desbloqueado' }}
                </b-dropdown-item>
                <b-dropdown-item @click="toggleDashboardLock(dashboardActive)">
                  <i :class="isDashboardLocked(dashboardActive) ? 'fa fa-unlock' : 'fa fa-lock'"></i>
                  {{ isDashboardLocked(dashboardActive) ? 'Desbloquear' : 'Bloquear' }}
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="openNewDashboard()" title="Agregar Panel de Control">
                  <i class="fa fa-plus"></i> Agregar panel
                </b-dropdown-item>
                <b-dropdown-item @click="openEditDashboard(dashboardActive)" title="Editar Panel de Control">
                  <i class="fa fa-edit"></i> Editar panel
                </b-dropdown-item>
                <b-dropdown-item @click="moveDashboard(dashboardActive, -1)" title="Mover a la izquierda">
                  <i class="fa fa-arrow-left"></i> Mover izquierda
                </b-dropdown-item>
                <b-dropdown-item @click="moveDashboard(dashboardActive, 1)" title="Mover a la derecha">
                  <i class="fa fa-arrow-right"></i> Mover derecha
                </b-dropdown-item>
                <b-dropdown-item @click="openImportDashboard()" title="Importar tablero">
                  <i class="fa fa-download"></i> Importar
                </b-dropdown-item>
                <b-dropdown-item @click="openDeleteDashboard(dashboardActive)" title="Eliminar panel de control">
                  <i class="fa fa-trash"></i> Eliminar
                </b-dropdown-item>
                <b-dropdown-divider v-if="!isDashboardLocked(dashboardActive)"></b-dropdown-divider>
                <b-dropdown-item v-if="!isDashboardLocked(dashboardActive)" @click="openAddWidget(dashboardActive)" title="Agregar Widgets">
                  <i class="icon-calculator"></i> Agregar widget
                </b-dropdown-item>
              </b-dropdown>
            </div>
            <WidgetMasonry
              v-if="getDashboardWidgets(value).length"
              :items="getDashboardWidgets(value)"
              :disabled="isMobile || isDashboardLocked(value)"
              :draggable="!isMobile && !isDashboardLocked(value)"
              :columns="dashboardGridColumns"
              @input="setDashboardWidgets(value, $event)"
              @order-end="onWidgetOrderEnd(value, $event)"
              @resize-end="onWidgetResizeEnd(value, $event)"
            >
              <template v-slot:default="{ item }">
                <Widget
                  :configWidget="getConfigWidget(item)"
                  :reference="item.reference"
                  :hasAccess="getHasAccessWidget(item)"
                  :isCustom="item.php_id > 0"
                  :allowDrag="!isMobile && !isDashboardLocked(value)"
                  :allowResize="!isMobile && !isDashboardLocked(value)"
                  :allowHide="!isDashboardLocked(value)"
                  @hide-widget="hideWidgetFromDashboard(value, item)"
                />
              </template>
            </WidgetMasonry>

            <b-row v-if="!getDashboardWidgets(value).length">
              <b-col>
                <b-jumbotron header="Widget"
                            lead="Agregá diferentes widgets para comenzar a controlar toda la información de tu empresa"
                            bg-variant="secondary">

                  <b-button @click="openAddWidget(value)" variant="dark" type="button">Agregar</b-button>
                </b-jumbotron>
              </b-col>
            </b-row>

          </b-card-text>

        </b-tab>
      </b-tabs>
    </b-card>
    <div v-else class="jumbotron-dashboard">
      <b-jumbotron header="Panel de Control"
                   lead="Creá multiples dashboard para monitorear todo lo que ocurre en tu empresa"
                   bg-variant="dark">

        <b-button @click="openNewDashboard()" variant="outline-secondary" type="button">Crear</b-button>
      </b-jumbotron>
    </div>

    <!-- ########################### -->
    <!-- #####     MODALES     ##### -->
    <!-- ########################### -->

    <!-- CRUD DASHBOARD -->
    <b-modal v-model="modal.form.active"
              header-bg-variant="dark"
              header-text-variant="white">
      <div slot="modal-header">
        {{this.modal.form.title}}
      </div>

      <b-row>
        <b-col md="12">
          <b-form-group label="Nombre">
            <b-form-input type="text"
                          size="sm"
                          v-model="form.name"
                          required
                          placeholder="Ingresar nombre del rol">
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <div slot="modal-footer">
        <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
        <b-button variant="dark" @click="saveDashboard()">Guardar</b-button>        
      </div>
    </b-modal>

    <!-- SELECT WIDGET -->
    <b-modal v-model="modal.widget.active"
              header-bg-variant="dark"
              header-text-variant="white"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close>

      <div slot="modal-header">
        {{this.modal.widget.title}}
      </div>

      <div role="tablist" v-if="arr.widget.length">
        <b-card no-body class="mb-1" v-for="(item, index) in arr.widget" :key="item.id" v-show="validateActiveModule(item)">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle="'accordion-' + index" variant="secondary" class="text-left">
              <b>Módulo:</b> {{item.name}}
            </b-button>
          </b-card-header>
          <b-collapse :id="'accordion-'+ index" visible accordion="my-accordion" role="tabpanel">
            <b-card-body>

              <b-list-group>
                <b-list-group-item href="#"
                                   class="flex-column align-items-start"                                                                      
                                   v-for="value in item.widget"
                                   :key="value.id"
                                   v-b-tooltip.hover title="Click para agregar widget"
                                   @click="confirmAddWidget(value)">

                  <div class="d-flex w-100 justify-content-between">
                    <h5 class="mb-1">{{value.title}}</h5>
                    <small>{{value.type}}</small>
                  </div>
                  <p class="mb-1">
                    {{value.description}}
                  </p>

                </b-list-group-item>
              </b-list-group>

            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <b-badge v-else variant="warning" class="p-3 badge-dashboard-widget-config">No hay widget para agregar</b-badge>

      <template v-slot:modal-footer>
        <button type="button" class="btn btn-outline-secondary mr-1" @click="cancelAddWidget()">Cancelar</button>
      </template>
    </b-modal>

    <!-- IMPORT DASHBOARD -->
    <b-modal v-model="modal.import.active"
              header-bg-variant="dark"
              header-text-variant="white">
      <div slot="modal-header">
        {{this.modal.import.title}}
      </div>

      <b-row>
        <b-col md="12">
          <b-form-group label="Usuario">
            <b-form-select v-model="importSelection.user_id" :options="importUserOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Tablero">
            <b-form-select v-model="importSelection.dashboard_id" :options="importDashboardOptions" :disabled="!importSelection.user_id"></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <template v-slot:modal-footer>
        <b-button variant="outline-secondary" class="mr-1" @click="modal.import.active=false">Cancelar</b-button>
        <b-button variant="dark" :disabled="!importSelection.dashboard_id" @click="confirmImportDashboard()">Importar</b-button>
      </template>
    </b-modal>

  </div>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Helper from '@/handler/helper'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Param from '@/config/parameters'
  import Widget from '@/components/inc/widget/widget'
  import WidgetMasonry from '@/components/inc/widget/WidgetMasonry'
  import Funciones from '@/handler/funciones'
  import Storage from '@/handler/storageLocal'

  export default {
    components: {
      Widget,
      WidgetMasonry
    },
    props: {
      profileID: {
        type: Number,
        required: true
      },
    },
    data: () => {
      return {
        configWidget: {
          module_id: 0,
          profile_id: 0,
          elements: {}
        },
        form: {
          id: 0,
          name: '',
          columns: 0,
          profile_id: 0,
        },
        modal: {
          form: {
            active: false,
            title: ''
          },
          widget: {
            active: false,
            title: ''
          },
          import: {
            active: false,
            title: ''
          }
        },
        arr: {
          dashboard: [],
          widget: []
        },
        dashboardWidgetsMap: {},
        dashboardSelection: {},
        dashboardActive: {},
        dashboardGridColumns: 12,
        isMobile: false,
        importUsers: [],
        importSelection: {
          user_id: null,
          dashboard_id: null
        },
        tabActive: 0,
      }
    },
    computed: {
      showDashboardActions() {
        return !!(this.arr.dashboard.length && this.dashboardActive && this.dashboardActive.id)
      },
      importUserOptions() {
        var options = [{ value: null, text: 'Seleccionar usuario' }]
        if(Array.isArray(this.importUsers)) {
          this.importUsers.forEach((user) => {
            options.push({
              value: user.id,
              text: user.name + (user.email ? ' (' + user.email + ')' : '')
            })
          })
        }
        return options
      },
      importDashboardOptions() {
        var options = [{ value: null, text: 'Seleccionar tablero' }]
        var user = this.importUsers.find(item => item.id === this.importSelection.user_id)
        if(user && Array.isArray(user.dashboards)) {
          user.dashboards.forEach((dashboard) => {
            options.push({
              value: dashboard.id,
              text: dashboard.name
            })
          })
        }
        return options
      }
    },
    created () {
      this.configWidget.profile_id = this.profileID
      this.form.profile_id = this.profileID

      window.addEventListener('resize', this.showColumnsDashboard);
    },
    mounted() {
      this.load()

      this.restoreStatusTabsStorage()
    },
    destroyed() {
      window.removeEventListener("resize", this.showColumnsDashboard);
    },          
    methods: {
      load () {
        this.arr.dashboard = []
        this.arr.widget = []
        this.dashboardWidgetsMap = {}

        this.loadDashboard()
        this.loadWidget()
      },
      loadDashboard () {
        this.arr.dashboard = Session.getSession().auth.user.dashboard
        if(this.arr.dashboard.length) {
          var storageTab = Storage.getValue('tabs_view_dashboard')
          var storedId = storageTab ? JSON.parse(storageTab) : 0
          var preferredId = this.tabActive || (this.dashboardActive && this.dashboardActive.id) || storedId
          var selected = this.arr.dashboard.find(item => item.id == preferredId)
          this.dashboardActive = selected || this.arr.dashboard[0]
          this.tabActive = this.dashboardActive.id
          this.showColumnsDashboard()
        }
      },
      loadWidget () {
        var arrWidget = Session.getSession().auth.user.permissions.widget
        var modules = []
        var widget = []
        var module_name = ''

        for (const prop in arrWidget) {
          var moduleName = (arrWidget[prop].php_id && arrWidget[prop].php_id > 0)
            ? 'php'
            : (arrWidget[prop].module && arrWidget[prop].module.name ? arrWidget[prop].module.name : 'Personal')
          modules[moduleName] = {}
          widget[moduleName] = []
        }

        for (const prop in arrWidget) {
          var moduleName = (arrWidget[prop].php_id && arrWidget[prop].php_id > 0)
            ? 'php'
            : (arrWidget[prop].module && arrWidget[prop].module.name ? arrWidget[prop].module.name : 'Personal')
          var moduleId = arrWidget[prop].module && arrWidget[prop].module.id ? arrWidget[prop].module.id : 1
          if(module_name != moduleName) {

            modules[moduleName] = {  id: moduleId, name: moduleName,}
            modules[moduleName]["widget"] = widget[moduleName]

            module_name = moduleName
          }

          widget[moduleName].push(arrWidget[prop])
        }

        for (const prop in modules) {
          this.arr.widget.push(modules[prop])
        }
      },
      openNewDashboard () {
        this.form.id = 0
        this.form.name = ''

        this.modal.form.title = "Crear Nuevo Panel de Control"
        this.modal.form.active = true
      },
      openEditDashboard (value) {
        this.form.id = value.id
        this.form.name = value.name

        this.modal.form.title = "Editar Panel de Control --> " + value.name
        this.modal.form.active = true
      },
      openDeleteDashboard (value) {
        this.form.id = value.id
        this.form.name = value.name

        this.$bvModal.msgBoxConfirm('¿Desea borrar el panel de control (' + this.form.name + ') y todos los widget configurados?', {
          title: 'Borrar >> Panel de control',
          size: 'lg',
          buttonSize: 'lg',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: "danger",
          headerTextVariant: "white",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            this.deleteDashboard()
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      saveDashboard () {
        let loader = this.$loading.show();
        if(this.form.id) {
          var result = serviceAPI.editar(this.form);
        } else {
          var result = serviceAPI.agregar(this.form);
        }

        result.then((response) => {
          var result_1 = serviceAPI.getSessionUser();
          result_1.then((response_1) => {
            var data = response_1.data

            Session.setSessionAuth(data)
            this.modal.form.active = false
            this.load()
            loader.hide()
            this.$awn.success("Panel de control guardado");
          })
          .catch(error_1 => {
            loader.hide()
            this.$awn.alert(Error.showError(error_1))
          })
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      deleteDashboard () {
        let loader = this.$loading.show();
        if (this.form.id) {
          var result = serviceAPI.eliminar(this.form.id);
        }

        result.then((response) => {
          var result_1 = serviceAPI.getSessionUser();
          result_1.then((response_1) => {
            var data = response_1.data

            Session.setSessionAuth(data)
            this.modal.form.active = false
            this.load()
            loader.hide()
            this.$awn.success("Panel de control eliminado");
          })
          .catch(error_1 => {
            loader.hide()
            this.$awn.alert(Error.showError(error_1))
          })
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      setDashboardActive(dashboard) {
        this.dashboardActive = dashboard
        this.tabActive = dashboard && dashboard.id ? dashboard.id : 0
        this.showColumnsDashboard()

        this.saveStatusTabsStorage()
      },
      showColumnsDashboard() {
        this.isMobile = window.innerWidth <= 992
        this.dashboardGridColumns = 12
      },
      openAddWidget (value) {
        var targetDashboard = value || this.dashboardActive || this.arr.dashboard.find(item => item.id == this.tabActive)
        if(!targetDashboard || !targetDashboard.id) {
          return
        }
        if(this.isDashboardLocked(targetDashboard)) {
          return
        }
        this.modal.widget.title = "Agregar Widgets"
        this.modal.widget.active = true

        this.dashboardSelection = targetDashboard
      },
      confirmAddWidget (item) {
        this.$bvModal.msgBoxConfirm('Agregar el widget (' + item.title + ') al panel de control?', {
          title: 'Widget >> Agregar',
          size: 'lg',
          buttonSize: 'lg',
          okVariant: 'success',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: "success",
          headerTextVariant: "white",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            this.addWidget(item)
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      cancelAddWidget (){
        this.modal.widget.active = false
        this.dashboardSelection = {}
      },
      addWidget (item) {
        let loader = this.$loading.show();

        var arrWidget = this.getDashboardWidgets(this.dashboardSelection).slice()
        arrWidget.push(item)

        var data = {
          id: this.dashboardSelection.id,
          data: arrWidget,
          type: 'add'
        }

        var result = serviceAPI.actualizarContenidoDashboard(data);

        result.then((response) => {
           var result_1 = serviceAPI.getSessionUser();
          result_1.then((response_1) => {
            var data = response_1.data

            Session.setSessionAuth(data)
            this.modal.widget.active = false
            this.load()
            loader.hide()
            this.$awn.success("Dashboard actualizado");
          })
          .catch(error_1 => {
            loader.hide()
            this.$awn.alert(Error.showError(error_1))
          })
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      getConfigWidget(item){
        var data = {
          module_id: item.php_id > 0 ? Modules.PHP : item.module_id,
          profile_id: this.profileID,
        }
        return data
      },
      getHasAccessWidget(item) {
        if(item.php_id > 0) {
          return Helper.hasAccessWidget({ module_id: Modules.PERSONAL, profile_id: this.profileID }, item.reference)
        }
        return Helper.hasAccessWidget(this.getConfigWidget(item), item.reference)
      },
      isDashboardLocked(dashboard) {
        if(!dashboard) {
          return false
        }
        const value = dashboard.locked
        return value === true || value === 1 || value === '1'
      },
      toggleDashboardLock(dashboard) {
        if(!dashboard || !dashboard.id) {
          return
        }
        var locked = !this.isDashboardLocked(dashboard)
        serviceAPI.actualizarLockDashboard(dashboard.id, locked)
          .then(() => serviceAPI.getSessionUser())
          .then((response) => {
            Session.setSessionAuth(response.data)
            this.load()
          })
          .catch((error) => {
            this.$awn.alert(Error.showError(error))
          })
      },
      validateActiveModule(item) {
        if(item.id === Modules.PHP && Helper.hasParametersAccess(Param.P70)) {
          return true
        }
        return Helper.moduleEnabled(item.id)
      },

      getDashboardWidgets(dashboard) {
        if(!dashboard || !dashboard.id) {
          return []
        }
        if(this.dashboardWidgetsMap[dashboard.id]) {
          return this.dashboardWidgetsMap[dashboard.id]
        }

        var parsed = []
        if(dashboard.data) {
          try {
            parsed = JSON.parse(dashboard.data)
          } catch (error) {
            parsed = []
          }
        }

        this.$set(this.dashboardWidgetsMap, dashboard.id, parsed)
        return parsed
      },
      setDashboardWidgets(dashboard, widgets) {
        if(!dashboard || !dashboard.id) {
          return
        }
        this.$set(this.dashboardWidgetsMap, dashboard.id, widgets || [])
      },
      onWidgetOrderEnd(dashboard, widgets) {
        if(this.isMobile) {
          return
        }
        this.setDashboardWidgets(dashboard, widgets)
        this.persistDashboardWidgets(dashboard, widgets)
      },
      onWidgetResizeEnd(dashboard, payload) {
        if(this.isMobile) {
          return
        }
        var list = this.getDashboardWidgets(dashboard).slice()
        var index = list.findIndex(item => item.reference === payload.reference)
        if(index === -1) {
          return
        }
        var current = list[index]
        var next = Object.assign({}, current)
        if(payload.cols !== undefined) {
          next.cols = payload.cols
        }
        if(payload.height !== undefined) {
          next.height = payload.height
        }
        list.splice(index, 1, next)
        this.setDashboardWidgets(dashboard, list)
        this.persistDashboardWidgets(dashboard, list)
      },
      hideWidgetFromDashboard(dashboard, item) {
        if(!item || !dashboard) {
          return
        }
        var list = this.getDashboardWidgets(dashboard).slice()
        var index = list.findIndex(entry => entry.reference === item.reference)
        if(index === -1) {
          return
        }
        list.splice(index, 1)
        this.setDashboardWidgets(dashboard, list)
        this.persistDashboardWidgets(dashboard, list)
      },
      persistDashboardWidgets(dashboard, widgets) {
        var data = {
          id: dashboard.id,
          data: widgets,
          type: 'config'
        }
        serviceAPI.actualizarContenidoDashboard(data)
          .then(() => serviceAPI.getSessionUser())
          .then((response) => {
            Session.setSessionAuth(response.data)
            this.load()
          })
          .catch((error) => {
            this.$awn.alert(Error.showError(error))
          })
      },

      // TABS SAVE
      saveStatusTabsStorage() {
        if(this.dashboardActive && this.dashboardActive.id) {
          Storage.setValue('tabs_view_dashboard', JSON.stringify(this.dashboardActive.id))
        }
      },
      restoreStatusTabsStorage() {
        if(Storage.getValue('tabs_view_dashboard')) {
          this.tabActive = JSON.parse(Storage.getValue('tabs_view_dashboard'))

          this.arr.dashboard.forEach((element)=> {
            if(element.id == this.tabActive) {
              this.dashboardActive = element
            }            
          })         
          this.showColumnsDashboard()          
        }         
      },
      moveDashboard(dashboard, direction) {
        var index = this.arr.dashboard.findIndex(item => item.id === dashboard.id)
        if(index === -1) {
          return
        }
        var nextIndex = index + direction
        if(nextIndex < 0 || nextIndex >= this.arr.dashboard.length) {
          return
        }
        var list = this.arr.dashboard.slice()
        var temp = list[index]
        list[index] = list[nextIndex]
        list[nextIndex] = temp
        this.arr.dashboard = list
        this.persistDashboardOrder()
      },
      persistDashboardOrder() {
        var order = this.arr.dashboard.map(item => item.id)
        serviceAPI.actualizarOrdenDashboard({ order: order })
          .then(() => serviceAPI.getSessionUser())
          .then((response) => {
            Session.setSessionAuth(response.data)
            this.load()
          })
          .catch((error) => {
            this.$awn.alert(Error.showError(error))
          })
      },
      openImportDashboard() {
        this.modal.import.title = "Importar Tablero"
        this.modal.import.active = true
        this.importSelection.user_id = null
        this.importSelection.dashboard_id = null
        this.loadImportOptions()
      },
      loadImportOptions() {
        serviceAPI.obtenerOpcionesImportacion()
          .then((response) => {
            this.importUsers = response.data || []
          })
          .catch((error) => {
            this.importUsers = []
            this.$awn.alert(Error.showError(error))
          })
      },
      confirmImportDashboard() {
        if(!this.importSelection.dashboard_id) {
          return
        }
        let loader = this.$loading.show();
        serviceAPI.importarDashboard({ dashboard_id: this.importSelection.dashboard_id })
          .then(() => serviceAPI.getSessionUser())
          .then((response) => {
            Session.setSessionAuth(response.data)
            this.modal.import.active = false
            this.load()
            loader.hide()
            this.$awn.success("Tablero importado");
          })
          .catch((error) => {
            loader.hide()
            this.$awn.alert(Error.showError(error))
          })
      },               
    }
  }
</script>
<style>
  #dashboard-custom .card-header-tabs {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  #dashboard-custom .dashboard-tabs-actions {
    margin-left: auto;
  }
  .buttons-dashboard-widgets {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  @media (max-width: 992px) {
    #dashboard-custom .card-header-tabs {
      flex-wrap: nowrap;
      overflow-x: auto;
      overflow-y: hidden;
      -webkit-overflow-scrolling: touch;
      padding-right: 0;
      scrollbar-width: none;
      white-space: nowrap;
      position: relative;
    }
    #dashboard-custom .card-header-tabs > .nav-item:not(.dashboard-tabs-actions) {
      flex: 0 0 auto;
      max-width: none;
    }
    #dashboard-custom .card-header-tabs::-webkit-scrollbar {
      display: none;
    }
    #dashboard-custom .card-header-tabs::before,
    #dashboard-custom .card-header-tabs::after {
      position: sticky;
      top: 0;
      z-index: 3;
      display: inline-flex;
      align-items: center;
      height: 100%;
      min-width: 20px;
      justify-content: center;
      padding: 0 6px;
      font-size: 18px;
      font-weight: 700;
      color: #343a40;
      pointer-events: none;
      text-shadow: 0 0 2px rgba(255, 255, 255, 0.9);
      background: linear-gradient(to right, rgba(233, 236, 239, 0.98), rgba(233, 236, 239, 0));
    }
    #dashboard-custom .card-header-tabs::before {
      content: "‹";
      left: 0;
    }
    #dashboard-custom .card-header-tabs::after {
      content: "›";
      right: 0;
      background: linear-gradient(to left, rgba(233, 236, 239, 0.98), rgba(233, 236, 239, 0));
    }
    #dashboard-custom .mobile-dashboard-actions {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 8px;
    }
  }
  .jumbotron-dashboard {
    z-index: 1000;
  }
  .badge-dashboard-widget-config {
    font-size: 15px;
    text-align: center;
    width: 100%;
  }
  .dashboard-lock-btn {
    font-size: 16px;
    color: #dc3545;
    cursor: pointer;
    animation: blink-lock-dashboard 1.5s ease-in-out infinite;
  }
  .dashboard-lock-btn:hover {
    color: #a71d2a;
  }
  .dashboard-lock-btn.is-locked {
    color: #343a40;
    animation: none;
  }
  .dashboard-lock-btn.is-locked:hover {
    color: #6c757d;
  }
  @keyframes blink-lock-dashboard {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.3; }
  }
  #dashboard-custom canvas {
    min-height: 400px;    
  }
</style>
